import { Injectable } from '@angular/core';

declare global {
	interface Window {
		dataLayer: Record<string, any>[];
	}
}

@Injectable({
	providedIn: 'root',
})
export class GtmService {
	constructor() {
		if (!window.dataLayer) {
			window.dataLayer = [];
		}
	}

	public pushEvent(event: Record<string, any>) {
		window.dataLayer.push(event);
	}
}
